import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Select from 'react-select';
import css from 'styled-jsx/css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const { className, styles } = css.resolve`
  .modal-dialog {
    margin-top: 75px;
  }
`;

export default memo(MobileMaintenanceFilters);

const selectOptions = [
  { label: 'Complete', value: 'complete' },
  { label: 'Upcoming', value: 'upcoming' },
  { label: 'Overdue', value: 'due' },
];

const selectStyles = {
  control: (base) => ({ ...base, boxShadow: 'none' }),
  indicatorSeparator: (base) => ({ ...base, display: 'none' }),
  option: (base) => ({
    ...base,
    backgroundColor: 'var(--white) !important',
    outline: 'none',
    padding: 0,
  }),
  placeholder: (base) => ({
    ...base,
    color: 'var(--text-light-gray)',
    fontWeight: 'normal',
  }),
};

function MobileMaintenanceFilters(props) {
  return (
    <Modal
      backdropClassName="bg-transparent"
      className={className}
      isOpen={props.isOpen}
      scrollable
      toggle={() => props.toggleModal(!props.isOpen)}
    >
      <ModalHeader
        className="border-bottom-0"
        toggle={() => props.toggleModal(!props.isOpen)}
      >
        <p className="mb-0 font-weight-normal nine-tenth-text">Filters</p>
      </ModalHeader>
      <ModalBody>
        <div className="form-group">
          <Select
            controlShouldRenderValue={false}
            formatOptionLabel={(opt) =>
              formatOptionLabel(opt, props.typeFilter)
            }
            isClearable={false}
            isOptionSelected={() => false}
            isSearchable={false}
            onChange={props.handleTypeFilterSelect}
            options={selectOptions}
            placeholder="Status"
            styles={selectStyles}
          />
        </div>
        <div className="form-group">
          <div className="input-group">
            <input
              className="form-control text-text-light-gray"
              name="scheduleNameSearch"
              onChange={props.handlePropUpdate}
              placeholder="Schedule"
              type="text"
              value={props.scheduleNameSearch}
            />
            <div className="input-group-append">
              <div className="input-group-text bg-white">
                <FontAwesomeIcon
                  className="text-text-light-gray"
                  icon={faSearch}
                  size="sm"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="form-group">
          <div className="input-group">
            <input
              className="form-control text-text-light-gray"
              name="reminderNameSearch"
              onChange={props.handlePropUpdate}
              placeholder="Reminder"
              type="text"
              value={props.reminderNameSearch}
            />
            <div className="input-group-append">
              <div className="input-group-text bg-white">
                <FontAwesomeIcon
                  className="text-text-light-gray"
                  icon={faSearch}
                  size="sm"
                />
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="align-items-center justify-content-center border-top-0">
        <button
          className="btn btn-block btn-outline-third-gray text-text-gray bg-white py-0"
          onClick={props.clearFilters}
        >
          Clear Filters
        </button>
      </ModalFooter>
      {styles}
    </Modal>
  );
}

MobileMaintenanceFilters.propTypes = {
  clearFilters: PropTypes.func,
  handlePropUpdate: PropTypes.func,
  handleTypeFilterSelect: PropTypes.func,
  isOpen: PropTypes.bool,
  reminderNameSearch: PropTypes.string,
  scheduleNameSearch: PropTypes.string,
  toggleModal: PropTypes.func,
  typeFilter: PropTypes.array,
};
MobileMaintenanceFilters.defaultProps = {};

function formatOptionLabel({ label, value }, selected) {
  const isSelected = selected.includes(value);
  return (
    <div className="input-group input-group-sm">
      <div className="input-group-prepend">
        <div className="input-group-text bg-white border-0">
          <input checked={isSelected} readOnly type="checkbox" />
        </div>
      </div>
      <input
        className="form-control border-0 bg-white px-0"
        readOnly
        type="text"
        value={label}
      />
    </div>
  );
}

formatOptionLabel.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
};
